<template>
  <div class="sidebar" @mouseleave="currentIndex=5">
    <ul class="sidebar-group">
      <li v-for="(item, index) in courseTypeList" :key="item.id" @click="goCoursetype(item,index)">
        <div>{{ item.name | namefilter}}</div>
        <a href="javascript:void(0)" target="_blank">{{ item.name }}</a>
      </li>
      <li style="width: 30%" @click="goCourseclass">
        <div style=" font-size: 1.5rem;line-height: 2rem;">...</div>
        <a href="javascript:void(0)" target="_blank">更多</a>
      </li>
    </ul>
  </div>
</template>
<script>
  import { getCoursePid} from '@/api/course.js'
export default {
  data () {
    return {
      currentIndex: 5
    }
  },
  props: {
    courseTypeList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    goCoursetype (item,index) {
      // getCoursePid(item.id).then(res => {
      let routeData = this.$router.resolve({ path: '/wapcoursetypeclassify',
        query: {
          // courseTypeId: item.id,
          courseTypeId: item.sonList[0].id,
          // currentFirstId: res.data.parentId,
          currentSecondId: item.sonList[0].id,
          status: 1,
          sourceType: 2,
          isOpen: 1,
          index: index
        } })
      window.open(routeData.href, '_self')
      // })
    },
    goCourseclass (){
      this.$router.push({path: '/wapcourseClassify'})
    }
  },
  filters: {
    namefilter (val) {
      return val.slice(0, 2);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/base.scss';
.sidebar {
  .sidebar-group{
    li{
      width: 33%;
      height:auto;
      /*float: left;*/
      display: inline-table;
      text-align: center;
      margin-bottom: 0.8rem;
      a{
        display: inline-block;
        width: 100%;
        height:auto;
        text-align: center;
        color: #444444;
      }
      div{
        width: 2.5rem;
        height:  2.5rem;
        border-radius: 50px;
        margin: 0 auto;
        margin-bottom: 0.6rem;
        color: #fff;
        text-align: center;
        line-height:2.5rem;
      }
    }
    li:first-child div{
      background-color: #2d73dc;
    }
    li:nth-child(6n-4) div{
      background-color: #2dc5dc;
    }
    li:nth-child(6n-3) div{
      background-color: #dc9c2d;
    }
    li:nth-child(6n-2) div{
      background-color: #fe003c;
    }
    li:nth-child(6n-1) div{
    background-color: #23303f;
    }
    li:nth-child(6n) div{
      background-color: #05d086;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/wapsidebar.vue